import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";
import BaseButton from "@/components/BaseButton";

type Props = {
  tw: boolean;
  fb: boolean;
  ggl: boolean;
};

export default defineComponent({
  name: "SocialLoginButton",
  functional: true,
  components: { BaseButton },
  props: {
    tw: { type: Boolean, default: false },
    fb: { type: Boolean, default: false },
    ggl: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    return h(
      BaseButton,
      {
        staticClass: "social-button",
        class: [
          ...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]),
          { __tw: ctx.props.tw, __fb: ctx.props.fb, __ggl: ctx.props.ggl },
          ctx.data.staticClass,
        ],
        props: { small: true },
        on: ctx.listeners,
      },
      [ctx.scopedSlots.default && ctx.scopedSlots.default({})]
    );
  },
});
